module.exports = __webpack_public_path__ + "static/media/padlock.3b561ee3.svg";